export const saveToken = token => localStorage.setItem('jwt', token);
export const getToken  = ()    => localStorage.getItem('jwt');
export const clearToken= ()    => localStorage.removeItem('jwt');

export const saveUser   = user => localStorage.setItem('user', JSON.stringify(user));
export const getUser    = ()   => JSON.parse(localStorage.getItem('user') || 'null');
export const clearUser  = ()   => localStorage.removeItem('user');

export function getAdminToken() {
    return localStorage.getItem('adminToken');
}

export function setAdminToken(t) {
    localStorage.setItem('adminToken', t);
}

export function clearAdminToken() {
    localStorage.removeItem('adminToken');
}
  